import React from 'react'

const IconAddRow = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g mask='url(#mask0_18139_20765)'>
        <path
          d='M9.45768 13.5752H10.541V10.3252H13.791V9.24186H10.541V5.99186H9.45768V9.24186H6.20768V10.3252H9.45768V13.5752ZM3.41602 16.3669V3.2002H16.5827V16.3669H3.41602ZM4.49935 15.2835H15.4993V4.28353H4.49935V15.2835Z'
          fill='#686867'
        />
      </g>
    </svg>
  )
}

export default IconAddRow
